import { render, staticRenderFns } from "./profitLq.vue?vue&type=template&id=7bc54d5e&scoped=true&"
import script from "./profitLq.vue?vue&type=script&lang=js&"
export * from "./profitLq.vue?vue&type=script&lang=js&"
import style0 from "./profitLq.vue?vue&type=style&index=0&id=7bc54d5e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc54d5e",
  null
  
)

export default component.exports